<template>
  <div class="title">
    <span class="icon left" v-if="obj.prev" @click.stop.prevent="obj.prev()"><i class="fas fa-chevron-left" /></span>
    <span class="icon right" v-if="obj.next" @click.stop.prevent="obj.next()"><i class="fas fa-chevron-right" /></span>
    <h1>{{obj.title||obj.name}}</h1>
  </div>
</template>

<script>
export default {
  props: ['obj']
}
</script>

<style lang="scss" scoped>
.title {
  margin: 1em 0;
  position: relative;
  h1 {
    text-align: center;
    width: auto;
    margin: 0 auto;
    font-size: 30px;
  }
  .icon {
    margin: 0 1em;
    line-height: 38px;
    width: 20px;
    position: absolute;
  }
  .left {
    left: 0;
  }
  .right {
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TitlePrevNext.vue